import colors from 'src/integration/styles/colors';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ComponentProps extends Component {
  children: ReactNode;
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h1-mob' | 'h2-mob' | 'h3-mob';
  color?: string;
}

const Header1 = styled.h1`
  ${() => css`
    color: ${colors.primaryYankeesBlue};
    font-size: 2.25rem;
    font-style: normal;
    font-weight: bold;
    line-height: 130%;
  `}
`;

const Header2 = styled.h2`
  ${() => css`
    color: ${colors.primaryYankeesBlue};
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `}
`;

const Header3 = styled.h3`
  ${() => css`
    color: ${colors.primaryDarkJungleGreen};
    font-size: 1.625rem;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  `}
`;

const Header4 = styled.h4<{
  $color?: string;
}>`
  ${( {$color}) => css`
    color: ${$color || colors.primaryDarkJungleGreen};
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  `}
`;

const Header5 = styled.h5<{
  $color?: string;
}>`
  ${( {$color}) => css`
    color: ${$color || colors.primaryYankeesBlue};
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
  `}
`;

const Header6 = styled.h6<{
  $color?: string;
}>`
  ${( {$color}) => css`
    color: ${$color || colors.primaryYankeesBlue};
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
  `}
`;

const Header1Mob = styled.h1`
  ${() => css`
    color: ${colors.primaryYankeesBlue};
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `}
`;

const Header2Mob = styled.h2`
  ${() => css`
    color: ${colors.primaryYankeesBlue};
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `}
`;

const Header3Mob = styled.h3`
  ${() => css`
    color: ${colors.primaryYankeesBlue};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `}
`;

const Header = ({ children, level, className, color }: ComponentProps) => {
  if (level === 'h6') {
    return <Header6 className={className} $color={color}>{children}</Header6>;
  }
  if (level === 'h5') {
    return <Header5 className={className} $color={color}>{children}</Header5>;
  }
  if (level === 'h4') {
    return <Header4 className={className} $color={color}>{children}</Header4>;
  }
  if (level === 'h3') {
    return <Header3 className={className}>{children}</Header3>;
  }

  if (level === 'h2') {
    return <Header2 className={className}>{children}</Header2>;
  }

  if (level === 'h1-mob') {
    return <Header1Mob className={className}>{children}</Header1Mob>;
  }

  if (level === 'h2-mob') {
    return <Header2Mob className={className}>{children}</Header2Mob>;
  }

  if (level === 'h3-mob') {
    return <Header3Mob className={className}>{children}</Header3Mob>;
  }

  return <Header1 className={className}>{children}</Header1>;
};

export default Header;
